export const attempt = <T>(
  maybeFailing: () => T,
): { success: true; value: T } | { success: false; error: unknown; value?: undefined } => {
  try {
    return { success: true, value: maybeFailing() };
  } catch (e: unknown) {
    return { success: false, error: e };
  }
};
